const extractPlansMigrate = (plans, contractPlan) => {
  const filtered = plans.filter(
    plan => plan.code !== contractPlan.plan.code && plan.active,
  )

  return filtered
}

export default extractPlansMigrate
